import script from "./TabsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsMenu.vue?vue&type=script&setup=true&lang=js"

import "./TabsMenu.vue?vue&type=style&index=0&id=03cf18b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cf18b5"]])

export default __exports__